import React from 'react';
import { withRouter } from 'react-router-dom';
import MetaTags from 'react-meta-tags';

import RegistrationHeader from '../common/components/RegistrationHeader.js';
import RegistrationFooter from '../common/components/RegistrationFooter.js';

const RegistrationThankYou = (props) => {

	/*
	const {
		location
	} = props;

	let type = '';
	const queryParameters = new URLSearchParams(location.search);
	if(queryParameters.has('type')) {
		type = queryParameters.get('type');
	}
	*/

	let displayText = null;
	displayText = <p>Thank you for registering for lessons.  A member of our staff will contact you shortly.</p>;

	return (
		<React.Fragment>
			<MetaTags>
				<title>Thank You</title>
				<meta name="description" content="Thank You for Registering"/>
				<meta property="og:title" content="Thank You for Registering" />
			</MetaTags>
			<RegistrationHeader />
			<main>
				<div className='content'>
					<div className='pageContent'>
						<h1>Thank You</h1>
						{displayText}
					</div>
				</div>
			</main>
			<RegistrationFooter />
		</React.Fragment>
	);
};

export default withRouter(RegistrationThankYou);
